import { AlertProps, Alert as AntAlert } from 'antd';
import './antStyle.scss';

const Alert: React.FC<AlertProps> = ({ ...props }) => {
  return <AntAlert {...props} className={`alert ${props.type}`} />;
};
export default Alert;
